export enum GameName {
    KLONDIKE = 'Klondike',
    SPIDER = 'Spider',
    FREECELL = 'Freecell',
    PYRAMID = 'Pyramid',
}
export enum DifficultyLevelType {
    KLONDIKE_RANDOM_3CARDS = 'KLONDIKE_RANDOM_3',
    KLONDIKE_MEDIUM_3CARDS = 'KLONDIKE_MEDIUM_3',
    KLONDIKE_HARD_3CARDS = 'KLONDIKE_HARD_3',
    KLONDIKE_EXPERT_3CARDS = 'KLONDIKE_EXPERT_3',
    KLONDIKE_MASTER_3CARDS = 'KLONDIKE_MASTER_3',

    KLONDIKE_RANDOM_1CARD = 'KLONDIKE_RANDOM_1',
    KLONDIKE_EASY_1CARD = 'KLONDIKE_EASY_1',
    KLONDIKE_MEDIUM_1CARD = 'KLONDIKE_MEDIUM_1',
    KLONDIKE_HARD_1CARD = 'KLONDIKE_HARD_1',
    KLONDIKE_EXPERT_1CARD = 'KLONDIKE_EXPERT_1',
    KLONDIKE_MASTER_1CARD = 'KLONDIKE_MASTER_1',

    SPIDER_EASY_1SUIT = 'SPIDER_EASY_1',
    SPIDER_MEDIUM_1SUIT = 'SPIDER_MEDIUM_1',
    SPIDER_HARD_1SUIT = 'SPIDER_HARD_1',
    SPIDER_EXPERT_1SUIT = 'SPIDER_EXPERT_1',
    SPIDER_MASTER_1SUIT = 'SPIDER_MASTER_1',

    // 2 Suits:
    SPIDER_HARD_2SUIT = 'SPIDER_HARD_2',
    SPIDER_EXPERT_2SUIT = 'SPIDER_EXPERT_2',
    SPIDER_MASTER_2SUIT = 'SPIDER_MASTER_2',
    // 4 Suits:
    SPIDER_EXPERT_4SUIT = 'SPIDER_EXPERT_4',
    SPIDER_MASTER_4SUIT = 'SPIDER_MASTER_4',

    FREECELL_EASY = 'FREECELL_EASY',
    FREECELL_MEDIUM = 'FREECELL_MEDIUM',
    FREECELL_HARD = 'FREECELL_HARD',
    FREECELL_EXPERT = 'FREECELL_EXPERT',
    FREECELL_MASTER = 'FREECELL_MASTER',

    PYRAMID_EASY = 'PYRAMID_EASY',
}

export const difficultyLevelData = {
    [DifficultyLevelType.KLONDIKE_RANDOM_1CARD]: { type: 'random', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_EASY_1CARD]: { type: 'easy', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_MEDIUM_1CARD]: { type: 'medium', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_HARD_1CARD]: { type: 'hard', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_EXPERT_1CARD]: { type: 'expert', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_MASTER_1CARD]: { type: 'master', name: GameName.KLONDIKE },

    [DifficultyLevelType.KLONDIKE_RANDOM_3CARDS]: { type: 'random', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_MEDIUM_3CARDS]: { type: 'medium', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_HARD_3CARDS]: { type: 'hard', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_EXPERT_3CARDS]: { type: 'expert', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_MASTER_3CARDS]: { type: 'master', name: GameName.KLONDIKE },

    [DifficultyLevelType.SPIDER_EASY_1SUIT]: { type: 'easy', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_MEDIUM_1SUIT]: { type: 'medium', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_HARD_1SUIT]: { type: 'hard', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_EXPERT_1SUIT]: { type: 'expert', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_MASTER_1SUIT]: { type: 'master', name: GameName.SPIDER },

    [DifficultyLevelType.SPIDER_HARD_2SUIT]: { type: 'hard', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_EXPERT_2SUIT]: { type: 'expert', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_MASTER_2SUIT]: { type: 'master', name: GameName.SPIDER },

    [DifficultyLevelType.SPIDER_EXPERT_4SUIT]: { type: 'expert', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_MASTER_4SUIT]: { type: 'master', name: GameName.SPIDER },

    [DifficultyLevelType.FREECELL_EASY]: { type: 'easy', name: GameName.FREECELL },
    [DifficultyLevelType.FREECELL_MEDIUM]: { type: 'medium', name: GameName.FREECELL },
    [DifficultyLevelType.FREECELL_HARD]: { type: 'hard', name: GameName.FREECELL },
    [DifficultyLevelType.FREECELL_EXPERT]: { type: 'expert', name: GameName.FREECELL },
    [DifficultyLevelType.FREECELL_MASTER]: { type: 'master', name: GameName.FREECELL },

    [DifficultyLevelType.PYRAMID_EASY]: { type: 'easy', name: GameName.PYRAMID },
};

export const difficultiesList = Object.keys(difficultyLevelData);
